
export function formatAsPercentage(num, style, minimumFractionDigits, maximumFractionDigits) {
  return new Intl.NumberFormat('default', {
    style,
    minimumFractionDigits,
    maximumFractionDigits
  }).format(num);
}
